import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const PhoneHint = styled.span`
  color: ${ColorPalette.HEX.DimGray};
  font-size: 14px;
  line-height: 28px;
  margin: 16px;

  @media ${({ theme }) => theme.device.mobile} {
    font-size: 14px;
    line-height: 18px;
    margin: 0;
  }
`;
